var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 17",
    width: 17,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "right-arrow-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #42424e } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s0",
    d: "m7.1 13.5q-0.3 0-0.5-0.2-0.1-0.1-0.1-0.2-0.1-0.1-0.1-0.3 0-0.1 0-0.3 0.1-0.1 0.1-0.2l3.2-3.8-3-3.8q-0.1-0.1-0.2-0.3 0-0.1 0-0.2 0-0.2 0.1-0.3 0.1-0.1 0.2-0.2 0.1-0.1 0.2-0.1 0.2-0.1 0.3-0.1 0.1 0 0.3 0.1 0.1 0.1 0.2 0.2l3.4 4.3q0.2 0.1 0.2 0.4 0 0.3-0.2 0.5l-3.5 4.2q-0.1 0.1-0.3 0.2-0.1 0.1-0.3 0.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.c8461190d39b778ce41ec98b6163cf0d.svg";
export { ForwardRef as ReactComponent };